<template>
  <div class="header" :class="{[`bg-${type}`]: type}" style="background-image: url('assets/img/pexels-tousif-khan-814667.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'primary',
        description: 'Header background type'
      }
    }
  }
</script>
<style>
</style>
